import axios, { AxiosResponse } from 'axios'
import router from '@/router'
import { ElMessage } from 'element-plus'
import store from '@/store'
import { getCookie, clearAllCookie } from '@/utils/cookei'
const service = axios.create({
    // baseURL:'https://chatppt.newacademic.net/api/',
    baseURL: store.state.baseUrl,
    // baseURL: window.location.origin + '/api/',
    // withCredentials: false,
})

// 请求拦截器
service.interceptors.request.use(
    (config: any) => {
        // 从r路由中获取token
        const token = getCookie('Token')
        console.log(token, 'getCookie')
        config.headers = { token: token, 'Accept-Language': getCookie('language') || 'English' }
        const netInfo:any = navigator
        let network = 'unknown'
        if (netInfo && netInfo.connection) {
            network = netInfo.connection.effectiveType
        }
        const track = {
            network: network,
            source: "web"
        }
        // 将track转为base64
        const trackBase64 = btoa(JSON.stringify(track))
        // if (config.url.includes('aippt/get_authcode') || config.url.includes('/aippt/track')) {
            config.headers = {
                token: token, 
                track: trackBase64
            }
        // }
        return config
    },
    (error: any) => {
        // do something with request error
        return Promise.reject(error)
    }
)
// 相应拦截器
service.interceptors.response.use(
    (response: AxiosResponse) => {
        const res = response.data
        if (res.code == 400) {
            localStorage.clear()
            if (res.msg == 'Token 为空') {
                ElMessage.error('Login has expired')
            }else{
                ElMessage.error(res.msg)
            }
            setTimeout(() => {
                clearAllCookie();
                window.location.reload();
            }, 2000);
        }
        return res
    },
    (error: any) => {
        console.log('err' + error) // for debug
      
        return Promise.reject(error)
    }
)
export default service
